import { render, staticRenderFns } from "./ComboView.vue?vue&type=template&id=1bfa3b40&scoped=true"
import script from "./ComboView.vue?vue&type=script&lang=js"
export * from "./ComboView.vue?vue&type=script&lang=js"
import style0 from "./ComboView.vue?vue&type=style&index=0&id=1bfa3b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa3b40",
  null
  
)

export default component.exports